<template>
  <div
    :class="[
      customisation.layout === 0 && customisation.menu === 0
        ? 'layout-0 menu-0'
        : '',
      customisation.layout === 0 && customisation.menu === 1
        ? 'layout-0 menu-1'
        : '',
    ]"
    class="home-wrapper h-full lg:h-screen flex flex-wrap lg:flex-nowrap"
  >
    <!-- Banner -->
    <div
      class="home-banner relative lg:h-full w-screen bg-center bg-cover flex items-end"
      :style="{ backgroundImage: 'url(' + settings.banner_hero + ')' }"
      :class="[
        userAccess ? 'admin' : '',
        settings.featured_posts.length > 0 ? 'lg:w-6/12' : 'lg:w-12/12',
      ]"
    >
      <div
        class="banner-text relative z-10 border-l-8 border-white p-6 pr-8 lg:pr-12 pb-4 mb-12 ml-12 mr-4 lg:mx-12 text-white"
      >
        <h1
          v-if="settings.profile_title && settings.profile_title !== 'false'"
          class="text-white mb-4"
        >
          {{ settings.profile_title }}
        </h1>
        <h4 v-if="settings.profile_sub_title" class="font-secondary mb-4">
          {{ settings.profile_sub_title }}
        </h4>
        <a v-if="settings.profile_description" @click="showReadMore"
          >More about us ></a
        >
      </div>
    </div>
    <!-- Featured posts -->
    <div
      v-if="settings.featured_posts.length > 0"
      class="h-auto lg:h-full w-screen lg:w-6/12"
    >
      <PostsFeatured />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shared } from '../../../../../../js/mixins/shared.js'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import PostsFeatured from './PostsFeatured.vue'

export default {
  components: {
    PostsFeatured,
  },

  mixins: [shared],

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      userAccess: 'shared/getUserAccess',
      customisation: 'careerwise/getCustomisation',
    }),
  },

  methods: {
    showReadMore() {
      EventBus.$emit('showModal', 'read-more')
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 1024px) {
  .home-banner {
    height: calc(100vh - 3rem);
  }
  .home-banner.admin {
    height: calc(100vh - 8rem);
  }
}

@media screen and (min-width: 1024px) {
  .home-wrapper.layout-0.menu-0 {
    height: calc(100vh - 3rem);
    width: calc(100vw - 14rem);
  }
  .home-wrapper.layout-0.menu-1 {
    height: calc(100vh - 3rem);
    width: calc(100vw - 4rem);
  }
}

.banner-text {
  height: fit-content;
}

.home-banner:before {
  position: absolute;
  height: 100%;
  width: 100%;
  content: '';
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.804359243697479) 0%,
    rgba(0, 0, 0, 0) 55%
  );
  z-index: 1;
}
</style>
